module.exports = __webpack_public_path__ + "img/odyssey19.6c7b264d.png";